import { render, staticRenderFns } from "./LichBieuKBAT.vue?vue&type=template&id=a3714cfa&"
import script from "./LichBieuKBAT.vue?vue&type=script&lang=js&"
export * from "./LichBieuKBAT.vue?vue&type=script&lang=js&"
import style0 from "./LichBieuKBAT.vue?vue&type=style&index=0&id=a3714cfa&prod&lang=scss&"
import style1 from "./LichBieuKBAT.vue?vue&type=style&index=1&id=a3714cfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports